import React from "react";
import LogoSection from "./LogoSection";
import MainMenus from "./MainMenus";

const Header = ({ benchId, benchName, benchCode }) => {
  return (
    <>
      <header className="fixed-header">
        <LogoSection benchName={benchName} benchCode={benchCode} />
        <MainMenus benchId={benchId} />
      </header>
    </>
  );
};

export default Header;
